import React from "react";
import isEqual from "react-fast-compare";
import { useCurrentWidth } from "../../../hooks/use-current-width";
import { CSSBreakpoint } from "../../../styles/breakpoints";

type MediaQueryProps = { atLeast: CSSBreakpoint } | { atMost: CSSBreakpoint };

export const MediaQueryRaw: React.FC<React.PropsWithChildren<MediaQueryProps>> = props => {
  const breakpoints: Array<CSSBreakpoint> = ["xs", "sm", "md", "lg", "xl"];
  const currentBreakpoint = useCurrentWidth();

  function shouldBeVisible() {
    if (!currentBreakpoint) {
      return;
    }

    //@ts-expect-error
    if (props.atLeast) {
      //@ts-expect-error
      const atLeast = props.atLeast;

      return currentBreakpoint && breakpoints.indexOf(atLeast) <= breakpoints.indexOf(currentBreakpoint);
      //@ts-expect-error
    } else if (props.atMost) {
      //@ts-expect-error
      const atMost = props.atMost;

      return currentBreakpoint && breakpoints.indexOf(atMost) >= breakpoints.indexOf(currentBreakpoint);
    } else {
      return false;
    }
  }

  return shouldBeVisible() ? <React.Fragment>{props.children}</React.Fragment> : null;
};

export const MediaQuery: React.FC<React.PropsWithChildren<MediaQueryProps>> = React.memo(MediaQueryRaw, isEqual);
